import { DropdownChangeEvent } from 'primeng/dropdown';
import {
  EoDropdownConfig,
  IEoDropdownConfig,
} from '../eo-dropdown/eo-dropdown.model';
import { Prefecture } from './prefecture.model';

export interface IEoPrefectureDropdownConfig extends IEoDropdownConfig<Prefecture> {
  type?: any;
  url?: string;
}

export class EoPrefectureDropdownConfig
  extends EoDropdownConfig<Prefecture>
  implements IEoPrefectureDropdownConfig
{
  override type?: any;
  url?: string;

  constructor();
  constructor(obj: IEoPrefectureDropdownConfig);
  constructor(obj?: IEoPrefectureDropdownConfig) {
    super(obj as IEoPrefectureDropdownConfig);
    this.type = 'prefectureDropdown';
    this.url = obj?.url;
    this.onChange = obj?.onChange;
  }
}
